import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

// export types
export type { BreadcrumbProps } from './Breadcrumb';
export type { BreadcrumbItemProps } from './BreadcrumbItem';

// export components
export { Breadcrumb, BreadcrumbItem };
export default Breadcrumb;
